import type { IconSvgObject } from './types';

const UserEdit01Icon: IconSvgObject = [
  ["path", { d: "M15.5 8C15.5 5.23858 13.2614 3 10.5 3C7.73858 3 5.5 5.23858 5.5 8C5.5 10.7614 7.73858 13 10.5 13C13.2614 13 15.5 10.7614 15.5 8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3.5 20C3.5 16.134 6.63401 13 10.5 13C11.775 13 12.9704 13.3409 14 13.9365", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20.3536 15.4393L19.0607 14.1464C18.8654 13.9512 18.5489 13.9512 18.3536 14.1464L14 18.5L13.5 21L16 20.5L20.3536 16.1464C20.5489 15.9512 20.5489 15.6346 20.3536 15.4393Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default UserEdit01Icon;
